export default __webpack_public_path__ + "static/media/main-banner3.026d9b07.jpg";